export const NotificationTypesCodes = Object.freeze({
	confirm: 1,
	simple: 3,
});

export const NotificationSettingsMode = {
	simple: 'simple',
	expert: 'expert',
};
